var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 0c8.83 0 16 7.17 16 16s-7.17 16-16 16S0 24.83 0 16 7.17 0 16 0zm-5.002 24.992V12.497H6.844v12.495h4.154zm14.976 0v-7.165c0-3.839-2.05-5.624-4.782-5.624-2.203 0-3.19 1.212-3.743 2.063v-1.77h-4.153c.055 1.173 0 12.496 0 12.496h4.153v-6.978c0-.374.027-.747.137-1.014.3-.746.984-1.519 2.13-1.519 1.503 0 2.105 1.147 2.105 2.826v6.685h4.153zM8.949 6.472c-1.421 0-2.35.934-2.35 2.159 0 1.199.9 2.159 2.295 2.159h.027c1.448 0 2.35-.96 2.35-2.16-.027-1.224-.902-2.158-2.322-2.158z"}));
}

Linkedin.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
